import * as React from 'react';
import { Text, Flex, AcceptIcon, ErrorIcon, Header} from '@fluentui/react-northstar';

export default class SSORedirectComponent extends React.Component<{notifySuccess(any);}, {}> {

    constructor(props) {
        super(props);
    }
    render() {
        const search = new URLSearchParams(window.location.search);
        const response = search.get("sso_response");
        const decodedResponse = atob(response);
        var parsedResponse = JSON.parse(decodedResponse);
        var instanceUrl = sessionStorage.getItem('instance_url');        
        var status, msg;
        var icon, title, subtitle;
        if (parsedResponse != null) {
            status = parsedResponse.status;
            if(status === 200){
                msg = parsedResponse.success?.msg;
                if (msg == 'Login Successfully') {
                    icon = <AcceptIcon size="largest"/>;
                    subtitle = "This window will close automatically, please don't close it!";
                    var self = this;
                    setTimeout(function () {
                        parsedResponse['instanceUrl'] = instanceUrl;
                        self.props.notifySuccess(parsedResponse);
                    }, 2000);
                }
                else {
                    icon = <ErrorIcon size="largest"/>;
                    subtitle = "Please ensure that your credentials are associated with the tenant specified";
                }
            }
            else{
                let errorMsg = parsedResponse.error;
                icon = <ErrorIcon size="largest"/>;
                subtitle = errorMsg ?? "Please ensure that your credentials are associated with the tenant specified";
            }                        
            title = msg;
        }
        return (
            <Flex column hAlign='center' vAlign='center' styles={{ width: '100%', margin: 'auto', paddingTop: '20px' }} gap='gap.medium'>
                {icon}
                <Header as='h3' content={title} />
                <Text content={subtitle} />
            </Flex>
        );
    }
}
